<template>
  <div class="images-view">
    <div class="row">
      <div class="col-md-12">
        <file-uploader
          :accept="fileUploaderAccept"
          ref="imageUploader"
          :items-prop="images"
          :in-progress="inProgress"
          :uploading-progress="uploadingProgress"
          :uploading-progress-value="uploadingProgressValue"
          @onImageDragChange="onImageDragChange"/>
      </div>
    </div>
    <div class="row" v-if="!hideSaveBtn">
      <div class="col-md-12 text-right">
        <submit-button :show-loader="inProgress"
                       :disabled="inProgress"
                       @click="save()"
                       class="mt-2">
          {{ $t('Save') }}
        </submit-button>
      </div>
    </div>
  </div>
</template>

<script>

  import {createNamespacedHelpers} from "vuex";
  import SubmitButton from "../../core/components/common/SubmitButton";
  import SalesService from "./SalesService";
  import FileUploader from "@/core/components/file-uploader/FileUploader";
  import InventoryService from "@/modules/inventory/InventoryService";

  const {mapState: mapStateGlobal} = createNamespacedHelpers('global');
  const {mapActions, mapState} = createNamespacedHelpers('sales');
  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "ImagesView",
    components: {FileUploader, SubmitButton},
    props: {
      saleUuid: {
        type: String,
        required: false,
      },
      hideSaveBtn: {
        type: Boolean,
        default: false
      },
      runPollingOnSave: {
        type: Boolean,
        default: true
      }
    },
    data: () => {
      return {
        inProgress: false,
        uploadingProgressValue: 0,
        uploadingProgress: false,
      };
    },
    computed: {
      ...mapStateGlobal(['videoFileFormats', 'videoMaxFileSize', 'imageFileFormats', 'imageMaxFileSize']),
      ...mapState({
        images: state => state.view.images,
      }),
      fileUploaderAccept() {
        return [
          {formats: this.videoFileFormats, maxSize: this.videoMaxFileSize},
          {formats: this.imageFileFormats, maxSize: this.imageMaxFileSize},
        ]
      }
    },
    watch: {
      saleUuid() {
        if (this.images.length === 0) {
          this.initImages();
        }
      }
    },
    methods: {
      ...mapActions(['getImages', 'updateImages']),
      init() {
        if (this.images.length > 0) {
          this.images.forEach((image) => {
            image.file = null;
            image.to_be_deleted = false
          });
          this.$refs.imageUploader.activeItemIndex = 0;
          this.runPolling(this.saleUuid);
        }
      },
      runPolling(saleUuid) {
        const needsPolling = this.images.find((item) => item.processing === true);

        if (!needsPolling) {
          return false;
        }

        this.inProgress = true;

        let pollingInterval = setInterval(async () => {
          let images = (await SalesService.getImages(saleUuid)).body;
          let shouldStopPolling = true;

          images.forEach((image) => {
            let item = this.images.find((item) => item.uuid === image.uuid);
            item.processing = image.processing;
            item.data = image.data;

            if (item.processing) {
              shouldStopPolling = false;
            }
          });

          if (shouldStopPolling) {
            this.$toast('success', this.$i18n.t('Images were successfully updated'));
            this.inProgress = false;
            clearInterval(pollingInterval);
          }
        }, 2000);

      },
      onImageDragChange(data) {
        this.updateImages(data)
      },
      async save(saleUuid = null) {
        if (!saleUuid) {
          saleUuid = this.saleUuid;
        }

        this.uploadingProgress = true;
        const progressEvent = (total, finished) => {
          this.uploadingProgressValue = parseInt("" + Math.round((finished / total) * 100));
        }
        let success, images = [], body, errorsList
        try {
          const res = await SalesService.createRenameAndDeleteImages(saleUuid, this.images, '/api/v1/auctions/images/', progressEvent)
          success = res.success
          images = res.images
          body = res.body
        } catch (err) {
          success = false
          images = null;
          body = err.body
          errorsList = err.errorsList
        }
        this.uploadingProgress = false;
        this.uploadingProgressValue = 0;

        if (success) {
          // Removing all elements from images which do not have uuid (not uploaded ones)
          // noinspection ES6MissingAwait
          this.updateImages([]);

          images.forEach((image) => {
            // Pushing newly uploaded images to images array
            image.file = null;
            this.images.push(image);
          });

          this.$refs.imageUploader.activeItemIndex = 0;
        } else {
          if (body instanceof Array) {
            const listImagesArr = [];
            body.filter(i => i.image).map(e => listImagesArr.push(this.$createElement('li', {}, e.image[0])))
            this.$errorDialog(this.$createElement('ul', {class: "mb-0"}, listImagesArr))
          } else if (errorsList instanceof Array && errorsList.length > 0) {
            this.$errorDialog(this.$createElement('ul', {class: "mb-0"}, errorsList))
          } else {
            this.$errorDialog(this.$i18n.t('Something went wrong when creating images'));
          }
          return false;
        }

        if (this.runPollingOnSave) {
          this.runPolling(saleUuid);
        }

        return true;
      },
      async initImages() {
        if (this.saleUuid) {
          await this.getImages(this.saleUuid);
          this.init();
        }
      },
      clearImages() {
        this.updateImages([]);
      }
    },
    async beforeMount() {
      this.clearImages();
      this.initImages();
    }
  }

</script>

<style lang="scss" scoped>
  @import "./scss/variables";
</style>
